import { useEffect, useState } from 'react';
import Student from './pages/Student';

type Route =
  | { kind: 'student' }
  | { kind: 'notfound' };

function parseRoute(): Route {
  const path = window.location.pathname || '/';
  // Root only — every other path is a 404. The legacy /s/:token flow is
  // intentionally gone (share tokens were removed; students connect to the
  // operator directly via /api/student/ws).
  if (path === '/' || path === '') return { kind: 'student' };
  return { kind: 'notfound' };
}

export default function App() {
  const [route, setRoute] = useState<Route>(() => parseRoute());

  useEffect(() => {
    const onPop = () => setRoute(parseRoute());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  if (route.kind === 'student') return <Student />;
  return (
    <div className="home">
      <p className="ghost">404</p>
    </div>
  );
}
